import React from "react";
import { useSelector } from "react-redux";
import { payment } from "../../../../../../../../../store/Concept/selectors";
import { Wrapper, Text } from "./styled";
import { getText } from "./functions";
import { DESCRIPTION } from "../../../../../Header/constants";

const Detail = ({ detail }) => {
  const data = useSelector(payment);
  const { paymentCoupon = "", paymentDate = "" } = data || {};

  if (!detail) {
    return (
      <Wrapper>
        <Text>{DESCRIPTION}</Text>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Text>{getText(paymentCoupon, paymentDate)}</Text>
    </Wrapper>
  );
};

export default Detail;
